// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"8b413df4","324":"b99e5bb2","488":"e75445ad","502":"b4684dc9","514":"c87cc8d8","529":"d417807b","623":"1231ac1f","749":"a701fefd"}[chunkId] + ".chunk.js";
};